export enum AnalysisForm {
    ITO = 'ITO',
    FULL = 'FULL'
}

const ANALYSIS_FORM_PREFIX = 'ENUM.ANALYIS_FORM.';

export function analysisFormTranslationKey(analysisForm: AnalysisForm | string | undefined): string {
    return ANALYSIS_FORM_PREFIX + analysisForm;
}

export const analysisFormTranslationKeys = Object.values(AnalysisForm).reduce((translationKeys, analysisForm) => {
    translationKeys[analysisForm] = analysisFormTranslationKey(analysisForm);
    return translationKeys;
}, {} as Record<AnalysisForm, string>);
